/**
 * cookieStorage.ts
 * 封装 cookie 存储，支持 expiration + SM2 加解密
 */

import sm2Util from './sm2Util'

function setCookie(name: string, value: string, expireMs: number) {
  let expires = ''
  if (expireMs > 0) {
    const d = new Date(Date.now() + expireMs)
    expires = '; expires=' + d.toUTCString()
  }
  document.cookie = `${name}=${encodeURIComponent(value)}${expires}; path=/`
}

function getCookie(name: string): string | null {
  const reg = new RegExp('(^| )' + name + '=([^;]+)')
  const match = document.cookie.match(reg)
  return match ? decodeURIComponent(match[2]) : null
}

function delCookie(name: string) {
  document.cookie = `${name}=; Max-Age=-1; path=/`
}

interface Options {
  expire?: number
  encrypt?: boolean
}
interface Stored {
  data: string
  expire: number
}

export default {
  set(key: string, value: any, options: Options = {}): boolean {
    const { expire = 0, encrypt = false } = options
    let str = typeof value === 'string' ? value : JSON.stringify(value)
    if (encrypt) {
      const enc = sm2Util.encrypt(str)
      if (!enc) return false
      str = enc
    }
    const expireAt = expire > 0 ? Date.now() + expire : 0
    const wrapped = JSON.stringify({ data: str, expire: expireAt })
    setCookie(key, wrapped, expire)
    return true
  },

  get(key: string, options: Options = {}) {
    const { encrypt = false } = options
    const raw = getCookie(key)
    if (!raw) return null
    let obj: Stored
    try {
      obj = JSON.parse(raw)
    } catch {
      return null
    }
    if (obj.expire && obj.expire < Date.now()) {
      delCookie(key)
      return null
    }
    let str = obj.data
    if (encrypt) {
      const dec = sm2Util.decrypt(str)
      if (dec === null) return null
      str = dec
    }
    try {
      return JSON.parse(str)
    } catch {
      return str
    }
  },

  remove(key: string) {
    delCookie(key)
  },

  clear() {
    document.cookie.split(';').forEach((c) => {
      const key = c.split('=')[0].trim()
      if (key) delCookie(key)
    })
  }
}
